'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ModalTransitionContext = require('../../context/ModalTransitionContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerMeasure = _styledComponents2.default.span.attrs({ 'aria-hidden': true }).withConfig({
  displayName: 'HiddenMeasure__InnerMeasure'
})(['overflow:hidden;position:absolute;left:0;max-width:100%;visibility:hidden;pointer-events:none;']);

// We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!
var hidePopoversContextValue = { transitioning: true };

var HiddenMeasure = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(
    _ModalTransitionContext.ModalTransitionContextProvider,
    { value: hidePopoversContextValue },
    _react2.default.createElement(InnerMeasure, _extends({}, props, { ref: ref }))
  );
});

exports.default = HiddenMeasure;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/layout/utils/HiddenMeasure.js
// module id = 462
// module chunks = 177